import React from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import LineFull from '../images/linefull.jpg';
import '../styles/app.scss';
import SEO from '../components/seo';

function getElementOffset(el) {
    let top = 0;
    let left = 0;
    let element = el;

    // Loop through the DOM tree
    // and add it's parent's offset to get page offset
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);

    return {
        top,
        left,
    };
}

const ParentsCorner = ({ data }) => {
    const { wordpressPage: post } = data;

    const test_title = post.yoast_title;
    const new_seo_title = test_title.replace('&#039;', "'");

    function handleAccordion(e) {
        const AccId = e.target.getAttribute('data-target');
        const buttonTriggers = document.querySelectorAll('.accordion-trigger');
        const accordionList = document.querySelectorAll('.collapse');

        // remove all arias from buttons
        buttonTriggers.forEach(button => {
            button.removeAttribute('aria-expanded');
            button.classList.add('collapsed');
        });
        e.target.classList.remove('collapsed');

        // hide all except clicked one
        accordionList.forEach(accordion => {
            const accContentId = accordion.getAttribute('id');
            if (accContentId !== AccId) {
                accordion.classList.remove('show');
            }
        });

        // e.target.setAttribute('aria-expanded', 'true');s
        const elementToShow = document.getElementById(AccId);
        const elementOffset = getElementOffset(e.target);

        // show hide element
        if (elementToShow.classList.contains('show')) {
            elementToShow.classList.remove('show');
            e.target.classList.add('collapsed');
        } else {
            elementToShow.classList.add('show');
            // scroll element into view
            window.scrollTo({
                top: elementOffset.top - 250,
                left: 0,
                behavior: 'smooth',
            });
        }
    }

    return (
        <>
            <SEO
                title={new_seo_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />

            <section className="page-section smallestwdt centersec">
                <div className="container">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: post.acf.faq_description,
                        }}
                    />
                    <img
                        className="schoolsline"
                        src={LineFull}
                        alt="linefull"
                    />

                    <div className="faq-anchors">
                        {post.acf.faq_sections.map((section, i) => {
                            const anchor = section.faq_title
                                .toLowerCase()
                                .replace(/\s+/g, '-')
                                .replace(/[^a-z0-9-]/g, '');
                            return (
                                <a
                                    key={i}
                                    href={`#${anchor}`}
                                    className="wrtsbtn yellowbtn"
                                >
                                    {section.faq_title}
                                </a>
                            );
                        })}
                    </div>

                    {post.acf.faq_sections.map((section, si) => {
                        const anchor = section.faq_title
                            .toLowerCase()
                            .replace(/\s+/g, '-')
                            .replace(/[^a-z0-9-]/g, '');
                        return (
                            <div className="faq-section faq-anchor-section" key={si} id={anchor} style={{ marginTop: '50px' }}>
                                <h2 className="bluetxt" style={{ textAlign: 'left' }}>
                                    {section.faq_title}
                                </h2>
                                <div
                                    className="accordion accordionfaq"
                                    id={`accordion-${anchor}`}
                                >
                                    {section.faq_list.map((faq, i) => {
                                        const collapseId = `collapse_${si}_${i}`;
                                        let classCollapse = 'collapse';
                                        let buttonCollapse =
                                            'btn btn-link collapsed accordion-trigger';
                                        if (i === 0) {
                                            classCollapse = 'collapse show';
                                            buttonCollapse =
                                                'btn btn-link accordion-trigger';
                                        }
                                        return (
                                            <div className="card" key={i}>
                                                <div
                                                    className="card-header"
                                                    id={`heading_${si}_${i}`}
                                                >
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={
                                                                buttonCollapse
                                                            }
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target={
                                                                collapseId
                                                            }
                                                            aria-expanded={
                                                                i === 0
                                                                    ? 'true'
                                                                    : 'false'
                                                            }
                                                            aria-controls={
                                                                collapseId
                                                            }
                                                            onClick={
                                                                handleAccordion
                                                            }
                                                            dangerouslySetInnerHTML={{
                                                                __html: faq.faq_question,
                                                            }}
                                                        />
                                                    </h2>
                                                </div>
                                                <div
                                                    id={collapseId}
                                                    className={classCollapse}
                                                    aria-labelledby={`heading_${si}_${i}`}
                                                    data-parent={`#accordion-${anchor}`}
                                                >
                                                    <div
                                                        className="card-body"
                                                        dangerouslySetInnerHTML={{
                                                            __html: faq.faq_answer,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
            <Footer />
        </>
    );
};
export default ParentsCorner;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            acf {
                faq_description
                faq_sections {
                    faq_title
                    faq_list {
                        faq_question
                        faq_answer
                    }
                }
            }
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
